import { call, put, select } from "redux-saga/effects";
import { actions as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";

export function* checkCPAndSetZones({ data }) {
  try {
    const { cp, needBussinesZone } = data;
    let module = yield call(() => import("@gerenciatd/next13.adabyron.geo.get-cp-zone"));
    module = module.default;

    const lastCP = yield select((state) => state.main.cp);
    const context = yield select((state) => state.main.context);

    // need get again bussinessZones, cuando montamos el modal con datos ya persistidos y no tenmoes la lista de municipios
    if (needBussinesZone) {
      yield put(mainActions.setCheckedCPByApi(false));
      let response = yield call(module, { cp, context });
      const { businessZones } = response;
      const lastZone = yield select((state) => state.main.zone);
      const lastMunicipio = yield select((state) => state.main.municipio);

      response = {
        cp: lastCP,
        zone: lastZone,
        municipio: lastMunicipio,
        businessZones,
      };
      yield put(mainActions.setCheckedCPByApi(true));
      yield put(mainActions.setCpParams(response));
    }

    // regular behaviour
    if (!needBussinesZone && lastCP !== cp) {
      yield put(mainActions.setCheckedCPByApi(false));
      let response = yield call(module, { cp, context });
      let zone = (response && response.zone) || "ZL";
      let municipio = null;
      // getting first result and using its zone
      if (
        response &&
        response.businessZones &&
        Array.isArray(response.businessZones) &&
        response.businessZones.length > 0
      ) {
        const { businessZoneName } = response.businessZones[0];
        zone = businessZoneName;
        municipio = response.businessZones[0];
      }

      response = {
        ...response,
        cp: response.postalCode,
        zone,
        municipio,
        persist: true
      };
      delete response.postalCode;
      yield put(mainActions.setCpParams(response));
      yield put(mainActions.setCheckedCPByApi(true));
    }
  } catch (err) {
    const responseMock = {
      persist: true,
      zone: 'ZL',
      businessZones: [
        {
          geographicAreaName: 'Madrid',
          businessZoneName: 'ZL',
        },
      ],
      cp: '28030',
      defaultValue: false,
    };
    yield put(mainActions.setCpParams(responseMock));
    yield put(mainActions.setCheckedCPByApi(true));
  }
}